module.exports = __webpack_public_path__ + "static/media/ArielRiderLogo.a4008332.avif";